import * as React from "react";

interface Props {
  viewBox?: string;
  color: string;
  size: string;
}

export const ProductBath = (props: Props) => (
  <svg
    width={props.size}
    height={props.size}
    viewBox={props?.viewBox}
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M1.25.5C.885.5.586.617.352.852.117 1.086 0 1.385 0 1.75v6.875c0 .846.234 1.634.703 2.363.43.69 1.029 1.276 1.797 1.758V15.5h9.375v-2.754c.768-.482 1.367-1.068 1.797-1.758a4.29 4.29 0 0 0 .703-2.363V8H6.25V1.75c0-.365-.117-.664-.352-.898C5.664.617 5.365.5 5 .5H1.25Zm0 1.25H5V8H1.25V1.75ZM2.5 3v1.875h1.25V3H2.5ZM1.445 9.25H12.93a3.996 3.996 0 0 1-.645 1.504 4.044 4.044 0 0 1-1.328 1.133l-.332.175v2.188H3.75v-2.188l-.332-.175c-.547-.3-.99-.677-1.328-1.133a3.996 3.996 0 0 1-.645-1.504Z"
      fill={props.color}
    />
  </svg>
);
